import type { CameraDistanceId, CameraPlatformId } from './presets.js';

export const CAMERA_GIMBAL_IDS = ['dynamic', 'steady', 'glide', 'float'] as const;
export type CameraGimbalId = typeof CAMERA_GIMBAL_IDS[number];
export const DEFAULT_CAMERA_GIMBAL: CameraGimbalId = 'glide';
export function adjustableCameraFraming(distance: CameraDistanceId): boolean {
  return distance === 'close' || distance === 'x-close' || distance === 'xx-close' || distance === 'telephoto-800';
}
/** Version-one profiles retain the values evaluated in the mountain comparison. */
export const CAMERA_GIMBALS = Object.freeze([
  { id: 'dynamic', label: 'Dynamic', seconds: 0, description: 'Responsive movement with no added height smoothing.' },
  { id: 'steady', label: 'Steady', seconds: .35, description: 'Gentle smoothing of camera and aim height.' },
  { id: 'glide', label: 'Glide', seconds: .8, description: 'Smooth tracking with terrain anticipation.' },
  { id: 'float', label: 'Float', seconds: 1.6, description: 'The strongest smoothing and terrain anticipation.' },
] satisfies { id: CameraGimbalId; label: string; seconds: number; description: string }[]);
export function effectiveCameraGimbal(mode: CameraGimbalId, distance: CameraDistanceId, style: CameraPlatformId): CameraGimbalId {
  if (style === 'uav' || style === 'night-hawk') return 'dynamic';
  return adjustableCameraFraming(distance) ? mode : 'dynamic';
}
export function gimbalSeconds(mode: CameraGimbalId): number { return CAMERA_GIMBALS.find(item => item.id === mode)!.seconds; }
export function paidCameraGimbal(mode: CameraGimbalId, distance: CameraDistanceId, style: CameraPlatformId): boolean {
  const effective = effectiveCameraGimbal(mode, distance, style);
  return adjustableCameraFraming(distance) && effective !== 'dynamic' && !(distance === 'close' && effective === 'steady');
}
